(function () {
  if (customElements.get('custom-promo-hero')) return;

  class CustomPromoHero extends HTMLElement {
    connectedCallback() {
      this.copyButtons = Array.from(this.querySelectorAll('[data-hero-copy]'));
      this.linkButtons = Array.from(this.querySelectorAll('.cph-promo-hero__button'));
      this.countdowns = Array.from(this.querySelectorAll('[data-hero-countdown]'));
      this.countdownTimer = null;
      this.abortController = new AbortController();

      this.bindEvents();
      this.startCountdowns();
    }

    disconnectedCallback() {
      this.stopCountdowns();
      if (this.abortController) this.abortController.abort();
    }

    bindEvents() {
      const { signal } = this.abortController;

      this.copyButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.copyCoupon(button);
        }, { signal });
      });

      this.linkButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (!this.isDesignMode()) return;

          event.preventDefault();
          event.stopPropagation();
        }, { signal });
      });
    }

    isDesignMode() {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }

    async copyCoupon(button) {
      const code = button.dataset.code;
      if (!code) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          this.fallbackCopy(code);
        }
        this.showCopyStatus(button, button.dataset.successText || 'Copied!');
      } catch (error) {
        this.showCopyStatus(button, button.dataset.errorText || 'Copy failed');
      }
    }

    fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    showCopyStatus(button, message) {
      const status = button.querySelector('[data-copy-status]');
      if (!status) return;

      status.textContent = message;
      window.clearTimeout(button._copyStatusTimer);
      button._copyStatusTimer = window.setTimeout(() => {
        status.textContent = '';
      }, 1800);
    }

    startCountdowns() {
      if (!this.countdowns.length) return;

      this.updateCountdowns();
      this.countdownTimer = window.setInterval(() => this.updateCountdowns(), 1000);
    }

    stopCountdowns() {
      if (!this.countdownTimer) return;
      window.clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }

    updateCountdowns() {
      this.countdowns.forEach((countdown) => {
        const endTime = Date.parse(countdown.dataset.endTime);
        if (Number.isNaN(endTime)) return;

        const remaining = Math.max(0, endTime - Date.now());
        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        this.setCountdownValue(countdown, 'days', days);
        this.setCountdownValue(countdown, 'hours', hours);
        this.setCountdownValue(countdown, 'minutes', minutes);
        this.setCountdownValue(countdown, 'seconds', seconds);
      });
    }

    setCountdownValue(countdown, key, value) {
      const node = countdown.querySelector(`[data-${key}]`);
      if (!node) return;
      node.textContent = String(value).padStart(2, '0');
    }
  }

  customElements.define('custom-promo-hero', CustomPromoHero);
})();
